<div #mapElement [id]="mapid" style="width: 100%; height: 100%"></div>
<div [id]="overviewid"></div>
<div [id]="rotateid"></div>
<div [id]="attributionid"></div>

<map-scaletext #mapScaletext></map-scaletext>
<map-tooltip #mapTooltip></map-tooltip>
@if (!isMapLoaded) {
  <mat-progress-spinner
    #progressSpinner
    mode="indeterminate"
    color="primary"
    strokeWidth="3"
    [diameter]="50"
    class="mapLoadProgressSpinner"
  ></mat-progress-spinner>
}

<div [ngClass]="rtl ? 'buttonPanelRtl' : 'buttonPanel'">
  <button
    #geoButton
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-GeoLocation')"
    (click)="centerGeoLocation()"
    [disabled]="!isMapGeoLocationActive"
    class="mapButton"
  >
    <mat-icon
      [svgIcon]="
        geoButton.disabled ? res.svgName('Map-GeoLocationDisabled-Image') : res.svgName('Map-GeoLocationEnabled-Image')
      "
    ></mat-icon>
  </button>
  @if (hasTargetUrlCopy || hasTargetUrlOpen) {
    <div
      [dir]="rtl ? 'rtl' : 'auto'"
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="8px"
      [ngClass]="{ toggleButtonDiv: !rtl, toggleButtonDivRtl: rtl }"
    >
      @if (isExtentMenuOpen()) {
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          @if (hasTargetUrlOpen) {
            <div>
              <mat-button-toggle
                (change)="openTargetUrl()"
                [matTooltip]="res.get('Map-TargetUrlOpen')"
                [aria-label]="res.get('Map-TargetUrlOpen')"
                [ngClass]="'toggleButton'"
              >
                <mat-icon [svgIcon]="res.svgName('Map-TargetUrlOpen-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
          @if (hasTargetUrlCopy) {
            <div>
              <mat-button-toggle
                (change)="copyTargetUrl()"
                [matTooltip]="res.get('Map-TargetUrlCopy')"
                [aria-label]="res.get('Map-TargetUrlCopy')"
                [ngClass]="'toggleButton'"
              >
                <mat-icon [svgIcon]="res.svgName('Map-TargetUrlCopy-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
          <div>
            <mat-button-toggle
              (change)="viewInitial()"
              [matTooltip]="res.get('Map-ViewInitial')"
              [aria-label]="res.get('Map-ViewInitial')"
              [ngClass]="'toggleButton'"
            >
              <mat-icon [svgIcon]="res.svgName('Map-ZoomFullExtent-Image')"></mat-icon>
            </mat-button-toggle>
          </div>
        </div>
      }
      <button
        mat-mdc-raised-button
        class="mapButton"
        [matTooltip]="res.get('Map-ExtentAction')"
        (click)="toggleExtentMenu()"
      >
        <mat-icon [svgIcon]="res.svgName('Map-ExtentAction-Image')"></mat-icon>
      </button>
    </div>
  } @else {
    <button
      mat-mdc-raised-button
      [matTooltip]="res.get('Map-ViewInitial')"
      (click)="viewInitial()"
      [disabled]="!isMapLoaded"
      class="mapButton"
    >
      <mat-icon [svgIcon]="res.svgName('Map-ZoomFullExtent-Image')"></mat-icon>
    </button>
  }
  <mat-button-toggle
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-ZoomWindow')"
    #toolZoomArea
    value="zoom_area"
    [disabled]="!isMapLoaded"
    (change)="onMeasureValChange(actionType.ZoomWin)"
    [ngClass]="{ mapButton: true, invisible: isMobileEnvironment }"
    class="toggleButton"
  >
    <mat-icon [svgIcon]="res.svgName('Map-ZoomWindow-Image')"></mat-icon>
  </mat-button-toggle>
  <button
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-ZoomIn')"
    (click)="viewZoomIn()"
    [disabled]="!isMapLoaded"
    [ngClass]="{
      mapButton: true,
      invisible: isMobileEnvironment,
    }"
  >
    <mat-icon [svgIcon]="res.svgName('Map-ZoomIn-Image')"></mat-icon>
  </button>
  <button
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-ZoomOut')"
    (click)="viewZoomOut()"
    [disabled]="!isMapLoaded"
    [ngClass]="{
      mapButton: true,
      invisible: isMobileEnvironment,
    }"
  >
    <mat-icon [svgIcon]="res.svgName('Map-ZoomOut-Image')"></mat-icon>
  </button>
  <button
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-ViewBack')"
    [disabled]="!enablePrevButton"
    (click)="viewBack()"
    [ngClass]="enablePrevButton ? 'mapButton' : 'mapButtonDisabled mapButton'"
  >
    <mat-icon [svgIcon]="res.svgName('Map-ZoomPrevious-Image')"></mat-icon>
  </button>
  <button
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-ViewNext')"
    [disabled]="!enableNextButton"
    (click)="viewNext()"
    [ngClass]="enableNextButton ? 'mapButton' : 'mapButtonDisabled mapButton'"
  >
    <mat-icon [svgIcon]="res.svgName('Map-ZoomNext-Image')"></mat-icon>
  </button>
  <mat-button-toggle
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-Pan')"
    #toolPan
    value="panMode"
    [disabled]="!isMapLoaded"
    (change)="onMeasureValChange(actionType.Pan)"
    [ngClass]="{ mapButton: true, invisible: isMobileEnvironment }"
    class="toggleButton"
  >
    <mat-icon [svgIcon]="res.svgName('Map-Pan-Image')"></mat-icon>
  </mat-button-toggle>
  <mat-button-toggle
    mat-mdc-raised-button
    [matTooltip]="res.get('Map-SelectEntities')"
    #toolSelectEntities
    value="select_entities"
    [disabled]="!isMapLoaded"
    (change)="onMeasureValChange(actionType.SelectEntities)"
    [ngClass]="{
      mapButton: true,
      invisible: !selectionEntitiesAction && !selectEntitiesDefaultAction,
    }"
    class="toggleButton"
  >
    <mat-icon [svgIcon]="res.svgName('Map-SelectEntities-Image')"></mat-icon>
  </mat-button-toggle>
  <div
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
    [dir]="rtl ? 'rtl' : 'auto'"
    [ngClass]="{ toggleButtonDiv: !rtl, toggleButtonDivRtl: rtl }"
  >
    @if (isMeasureMenuOpen() || isMeasureAction()) {
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        @if (!isMeasureAction() || isMeasureAction(actionType.MeasureCoord)) {
          <div>
            <mat-button-toggle
              #toolMeasureCoord
              value="measure_coord"
              (change)="onMeasureValChange(actionType.MeasureCoord)"
              [matTooltip]="res.get('Map-MeasureCoordinates')"
              [aria-label]="res.get('Map-MeasureCoordinates')"
              [ngClass]="'toggleButton'"
            >
              <mat-icon [svgIcon]="res.svgName('Map-MeasureCoordinates-Image')"></mat-icon>
            </mat-button-toggle>
          </div>
        }
        @if (!isMeasureAction() || isMeasureAction(actionType.MeasureLine)) {
          <div>
            <mat-button-toggle
              #toolMeasureLine
              value="measure_line"
              (change)="onMeasureValChange(actionType.MeasureLine)"
              [matTooltip]="res.get('Map-MeasureLine')"
              [aria-label]="res.get('Map-MeasureLine')"
              [ngClass]="'toggleButton'"
            >
              <mat-icon [svgIcon]="res.svgName('Map-MeasureLength-Image')"></mat-icon>
            </mat-button-toggle>
          </div>
        }
        @if (!isMeasureAction() || isMeasureAction(actionType.MeasureArea)) {
          <div>
            <mat-button-toggle
              #toolMeasureArea
              value="measure_area"
              (change)="onMeasureValChange(actionType.MeasureArea)"
              [matTooltip]="res.get('Map-MeasureArea')"
              [aria-label]="res.get('Map-MeasureArea')"
              [ngClass]="'toggleButton'"
            >
              <mat-icon [svgIcon]="res.svgName('Map-MeasureArea-Image')"></mat-icon>
            </mat-button-toggle>
          </div>
        }
      </div>
    }
    @if (!isMeasureAction()) {
      <button
        #groupTool
        mat-mdc-raised-button
        class="mapButton"
        [matTooltip]="res.get('Map-MeasureOption')"
        [disabled]="!isMapLoaded"
        (click)="toggleMeasureMenu()"
      >
        <mat-icon [svgIcon]="res.svgName('Map-MeasureOpenClose-Image')"></mat-icon>
      </button>
    }
  </div>

  @if (isMapPrintAvailable()) {
    <button
      mat-mdc-raised-button
      [matTooltip]="res.get('Map-Print')"
      [disabled]="!isMapLoaded || this.action === ActionType.PrintMap"
      (click)="openPrintDialog()"
      [ngClass]="{ mapButton: true, invisible: isMobileEnvironment }"
    >
      <mat-icon [svgIcon]="res.svgName('Map-Print-Image')"></mat-icon>
    </button>
  }

  @if (hasEditGeometryPoint || hasEditGeometryLine || hasEditGeometryPolygon || hasActionNewTicket) {
    <div
      [dir]="rtl ? 'rtl' : 'auto'"
      fxLayout="row"
      fxLayoutAlign="end center"
      fxLayoutGap="8px"
      [ngClass]="{ toggleButtonDiv: !rtl, toggleButtonDivRtl: rtl }"
    >
      @if (isConstructionMenuOpen() || isConstructionAction()) {
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          @if (hasActionNewTicket && (!isConstructionAction() || isConstructionAction(actionType.InsertTicket))) {
            <div>
              <mat-button-toggle
                #toolAddTicket
                value="ticket"
                (change)="onMeasureValChange(actionType.InsertTicket)"
                [matTooltip]="res.get('Map-NewTicket')"
                [aria-label]="res.get('Map-NewTicket')"
                [ngClass]="!isConstructionMenuDisabled() ? 'toggleButton' : 'mapToggleButtonDisabled toggleButton'"
                [disabled]="isConstructionMenuDisabled()"
              >
                <mat-icon [svgIcon]="res.svgName('Map-NewTicket-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
          @if (hasEditGeometryPoint && (!isConstructionAction() || isConstructionAction(actionType.InsertPoint))) {
            <div>
              <mat-button-toggle
                #toolAddPoint
                value="point"
                (change)="onMeasureValChange(actionType.InsertPoint)"
                [matTooltip]="res.get('Map-InsertPoint')"
                [aria-label]="res.get('Map-InsertPoint')"
                [ngClass]="!isConstructionMenuDisabled() ? 'toggleButton' : 'mapToggleButtonDisabled toggleButton'"
                [disabled]="isConstructionMenuDisabled()"
              >
                <mat-icon [svgIcon]="res.svgName('Map-NewPoint-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
          @if (hasEditGeometryLine && (!isConstructionAction() || isConstructionAction(actionType.InsertLine))) {
            <div>
              <mat-button-toggle
                #toolAddLine
                value="line"
                (change)="onMeasureValChange(actionType.InsertLine)"
                [matTooltip]="res.get('Map-InsertLine')"
                [aria-label]="res.get('Map-InsertLine')"
                [ngClass]="!isConstructionMenuDisabled() ? 'toggleButton' : 'mapToggleButtonDisabled toggleButton'"
                [disabled]="isConstructionMenuDisabled()"
              >
                <mat-icon [svgIcon]="res.svgName('Map-NewLine-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
          @if (hasEditGeometryPolygon && (!isConstructionAction() || isConstructionAction(actionType.InsertPolygon))) {
            <div>
              <mat-button-toggle
                #toolAddPolygon
                value="polygon"
                (change)="onMeasureValChange(actionType.InsertPolygon)"
                [matTooltip]="res.get('Map-InsertPolygone')"
                [aria-label]="res.get('Map-InsertPolygone')"
                [ngClass]="!isConstructionMenuDisabled() ? 'toggleButton' : 'mapToggleButtonDisabled toggleButton'"
                [disabled]="isConstructionMenuDisabled()"
              >
                <mat-icon [svgIcon]="res.svgName('Map-NewPolygon-Image')"></mat-icon>
              </mat-button-toggle>
            </div>
          }
        </div>
      }
      @if (!isConstructionAction()) {
        <button
          #groupTool
          mat-raised-button
          [ngClass]="'mapButton'"
          [matTooltip]="res.get('Map-AddObject')"
          (click)="toggleConstructionMenu()"
        >
          <mat-icon [svgIcon]="res.svgName('Map-NewOpenClose-Image')"></mat-icon>
        </button>
      }
    </div>
  }
</div>

<ng-template fc-host> </ng-template>

<div #abcWindowContainer></div>
